import {
    Splide,
} from '@splidejs/splide';
import {
    AutoScroll,
} from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', () => {
    const logoCarouselSections = document.querySelectorAll('.image-gallery-section');
    const splideInstances = new WeakMap(); // Track Splide instances for ≤ 3 items

    const handleSmallCarousel = (logoElement, itemCount) => {
        const existing = splideInstances.get(logoElement);
        const isMobile = window.innerWidth <= 767;

        if (itemCount <= 3) {
            if (isMobile && !existing) {
                const splide = new Splide(logoElement, {
                    type: 'slide',
                    drag: true,
                    arrows: false,
                    pagination: true,
                    autoWidth: true,
                });
                splide.mount();
                splideInstances.set(logoElement, splide);
            }

            if (!isMobile && existing) {
                existing.destroy(true);
                splideInstances.delete(logoElement);

                logoElement.classList.remove('is-initialized', 'is-overflow');
            }
        }
    };

    const initSplide = () => {
        logoCarouselSections.forEach(section => {
            const logoSplideElements = section.querySelectorAll('.igs-carousel');

            logoSplideElements.forEach(logoElement => {
                const logos = logoElement.querySelectorAll('.igs-item');
                const itemCount = logos.length;
                const speed = logoElement.getAttribute('data-speed') || 0.5;

                if (itemCount > 3) {
                    const splide = new Splide(logoElement, {
                        type: 'loop',
                        drag: false,
                        arrows: false,
                        pagination: false,
                        autoWidth: true,
                        autoScroll: {
                            speed: speed,
                            pauseOnHover: true,
                        },
                        breakpoints: {
                            767: {
                                drag: true,
                                pagination: true,
                                focus: 'center',
                                autoScroll: {
                                    pauseOnHover: false,
                                },
                            },
                        },
                    });
                    splide.on('mounted', () => {
                        const pagination = logoElement.querySelector('.splide__pagination');
                        if (pagination) {
                            pagination.addEventListener('click', (event) => {
                                if (event.target.classList.contains('splide__pagination__page')) {
                                    splide.Components.AutoScroll.pause();
                                    setTimeout(() => {
                                        splide.Components.AutoScroll.play();
                                    }, 600);
                                }
                            });
                        }
                    });
                    splide.mount({
                        AutoScroll,
                    });
                } else {
                    handleSmallCarousel(logoElement, itemCount);
                }
            });
        });
    };

    // Initial setup
    initSplide();

    // Re-run only the ≤ 3 item logic on resize
    window.addEventListener('resize', () => {
        logoCarouselSections.forEach(section => {
            const logoSplideElements = section.querySelectorAll('.igs-carousel');

            logoSplideElements.forEach(logoElement => {
                const logos = logoElement.querySelectorAll('.igs-item');
                const itemCount = logos.length;

                if (itemCount <= 3) {
                    handleSmallCarousel(logoElement, itemCount);
                }
            });
        });
    });
});
